import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import config from "../common/Config";
import generateManifestListPDF from './ManifestPrintPDF';
import MapRoute from './MapRoute';
import {
  Box,
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  Grid2,
  Divider,
} from '@mui/material';
import { Iconify } from '../Minimal/src/components/iconify/iconify';
import "../common/commonStyles.css";

const ManifestPrint = () => {
  const { manifestId } = useParams();
  const accessToken = localStorage.getItem('accessToken');
  const token = localStorage.getItem('token');
  const [showMap, setShowMap] = useState(false);
  const [headerData, setHeaderData] = useState({
    date: '',
    journeyNo: '',
    salesRep: '',
    driver: '',
    shop_name: '',
    address: '',
    phone: '',
    email: '',
    website: '',
  });
  const [manifestList, setmanifestList] = useState([]);

  const handleGenerateManifestListPDF = () => {
    generateManifestListPDF(manifestId);
  };

  const fetchViewManifestList = async () => {
    const formData = new FormData();
    formData.set('manifest_id', manifestId);

    const apiUrl = `${config.API_URL}/get_manifestPrint`;
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to fetch Picker List');
      }
      const data = await response.json();
      setHeaderData({
        date: data.data.date,
        journeyNo: data.data.route_id,
        salesRep: data.data.sale_rep,
        driver: data.data.driver_name,
        shop_name: data.data.shop_details.shop_name,
        address: data.data.shop_details.address,
        phone: data.data.shop_details.phone,
        email: data.data.shop_details.email,
        website: data.data.shop_details.website,
      });
      setmanifestList(data.data.inwards || []);
    } catch (error) {
      console.error('Error fetching Picker List data:', error);
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchViewManifestList();
  }, []);

  const cashOrders = manifestList.filter(order => 
    !order.credit_type || order.credit_type.every(type => !type.name)
  );

  const creditOrders = manifestList.filter(order => 
    order.credit_type && order.credit_type.some(type => type.name === 'amount_wise' || type.name === 'day_wise')
  );

  const tcOrders = manifestList.filter(order => 
    order.credit_type && order.credit_type.some(type => type.name === 'invoice_wise')
  );

  return (
    <>
      {/* <Header /> */}
      <Box className="page-container">
        <Paper className="paper-style">
            <Box sx={{ px: 2, py: 1.2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2 }}>
                <Typography className="page-title">
                  Manifest List
                </Typography>
                <Button
                  variant="contained"
                  size="medium"
                  className="button-variant-contained"
                  startIcon={<Iconify icon="eva:printer-fill" width={18} />}
                  onClick={handleGenerateManifestListPDF}
                 
                >
                  Print
                </Button>
              </Box>

              {showMap && <MapRoute />}

              <Box sx={{ mb: 3 }}>
                <Grid2 container spacing={3} alignItems="center">
                  <Grid2 size={{ xs: 12, sm: 4 }}>
                    <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                      <Box
                        component="img"
                        src={`${config.BASE_URL}/assets/img/${accessToken}_logo.png`}
                        alt="Logo"
                        sx={{
                          width: '100%',
                          maxWidth: 160,
                          height: 'auto',
                          maxHeight: 70,
                          objectFit: 'contain',
                        }}
                      />
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 8 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600}}>
                      {headerData.shop_name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#000"}}>
                      {headerData.address}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#000"}}>
                      <strong>Phone No:</strong> {headerData.phone} | <strong>Email:</strong> {headerData.email}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#000" }}>
                      <strong>Website:</strong> {headerData.website}
                    </Typography>
                  </Grid2>
                </Grid2>
              </Box>

              <Box sx={{ mb: 3 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 1,
                    border: '1px solid rgba(23, 24, 24, 0.6)',
                    borderRadius: 1,
                  }}
                >
                  <Grid2 container spacing={1}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <Typography variant="body2" sx={{ color: "#000"}}>
                        <strong>Manifest No:</strong> {manifestId}
                      </Typography>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <Typography variant="body2" sx={{ color: "#000"}}>
                        <strong>Date:</strong> {headerData.date}
                      </Typography>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <Typography variant="body2" sx={{ color: "#000"}}>
                        <strong>Journey No:</strong> {headerData.journeyNo}
                      </Typography>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <Typography variant="body2" sx={{ color: "#000"}}>
                        <strong>SalesRep Name:</strong> {headerData.salesRep}
                      </Typography>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                      <Typography variant="body2" sx={{ color: "#000"}}>
                        <strong>Driver Name:</strong> {headerData.driver}
                      </Typography>
                    </Grid2>
                  </Grid2>
                </Paper>
              </Box>

              <TableContainer >
                <Table
                  size="small"
                  className="table-cell-border"
                >
                  <TableHead>
                    <TableRow className="table-cell-header">
                      {["Customer name (A/C No)", "Inv No", "Inv Amt", "Total Dues", "Rep Collect", "Driver to Collect", "Remark"].map((header) => {
                        let align = "left";
                        if (header === "Inv Amt" || header === "Total Dues" || header === "Rep Collect" || header === "Driver to Collect") {
                          align = "right";
                        }
                        return (
                          <TableCell
                            key={header}
                            align={align}
                           
                          >
                            {header}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cashOrders.length > 0 && (
                      <>
                        <TableRow>
                          <TableCell colSpan={7} align="center" sx={{ py: 1.5, fontWeight: 600, fontSize: '0.875rem', backgroundColor: "rgba(145, 158, 171, 0.08)" }}>
                            Cash
                          </TableCell>
                        </TableRow>
                        {cashOrders.map((order, index) => (
                          <TableRow
                            key={`cash-row-${index}`}
                            hover
                            className="table-cell-style"
                          >
                            <TableCell align="left">
                              {order.customer || 'N/A'} ({order.accound_no || 'N/A'})
                            </TableCell>
                            <TableCell align="left">
                              {order.reference_no || 'N/A'}
                            </TableCell>
                            <TableCell align="right">
                              £ {order.grand_total || '0.00'}
                            </TableCell>
                            <TableCell align="right">
                              £ {order.get_total || '0.00'}
                            </TableCell>
                            <TableCell align="right">
                              £ {order.sale_person_collected || '0.00'}
                            </TableCell>
                            <TableCell align="right">
                              {order.driver_to_collect || ''}
                            </TableCell>
                            <TableCell align="left">
                              {order.remark || ''}
                            </TableCell>
                          </TableRow>
                        ))}
                      </>
                    )}

                    {creditOrders.length > 0 && (
                      <>
                        <TableRow>
                          <TableCell colSpan={7} align="center" sx={{ py: 1.5, fontWeight: 600, fontSize: '0.875rem', backgroundColor: "rgba(145, 158, 171, 0.08)" }}>
                            Credit
                          </TableCell>
                        </TableRow>
                        {creditOrders.map((order, index) => (
                          <TableRow
                            key={`credit-row-${index}`}
                            hover
                            className="table-cell-style"
                          >
                            <TableCell align="left" className="table-cell-style">
                              {order.customer || 'N/A'} ({order.accound_no || 'N/A'})
                            </TableCell>
                            <TableCell align="left" className="table-cell-style">
                              {order.reference_no || 'N/A'}
                            </TableCell>
                            <TableCell align="right" className="table-cell-style">
                              £ {order.grand_total || '0.00'}
                            </TableCell>
                            <TableCell align="right" className="table-cell-style">
                              £ {order.get_total || '0.00'}
                            </TableCell>
                            <TableCell align="right" className="table-cell-style">
                              £ {order.sale_person_collected || '0.00'}
                            </TableCell>
                            <TableCell align="right" className="table-cell-style">
                              {order.driver_to_collect || ''}
                            </TableCell>
                            <TableCell align="left" className="table-cell-style">
                              {order.remark || ''}
                            </TableCell>
                          </TableRow>
                        ))}
                      </>
                    )}

                    {tcOrders.length > 0 && (
                      <>
                        <TableRow>
                          <TableCell colSpan={7} align="center" sx={{ py: 1.5, fontWeight: 600, fontSize: '0.875rem', backgroundColor: "rgba(145, 158, 171, 0.08)" }}>
                            TC
                          </TableCell>
                        </TableRow>
                        {tcOrders.map((order, index) => (
                          <TableRow
                            key={`tc-row-${index}`}
                            hover
                            className="table-cell-style"
                          >
                            <TableCell align="left" >
                              {order.customer || 'N/A'} ({order.accound_no || 'N/A'})
                            </TableCell>
                            <TableCell align="left" >
                              {order.reference_no || 'N/A'}
                            </TableCell>
                            <TableCell align="right" >
                              £ {order.grand_total || '0.00'}
                            </TableCell>
                            <TableCell align="right" >
                              £ {order.get_total || '0.00'}
                            </TableCell>
                            <TableCell align="right" >
                              £ {order.sale_person_collected || '0.00'}
                            </TableCell>
                            <TableCell align="right" >
                              {order.driver_to_collect || ''}
                            </TableCell>
                            <TableCell align="left" >
                              {order.remark || ''}
                            </TableCell>
                          </TableRow>
                        ))}
                      </>
                    )}

                    {manifestList.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                          <Typography variant="body2" color="text.secondary">
                            No records found.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Paper>
        </Box>
  
    </>
  );
}

export default ManifestPrint;
